/** Anzeige: echte Nummer oder Offline-Platzhalter. */
export function formatCaseNumber(caseNumber: string | null | undefined): string {
  if (caseNumber && caseNumber.trim()) return caseNumber.trim();
  return "Nummer folgt";
}
